import React from 'react';
import { Link } from 'react-router-dom';
import { AUTH_PATHS } from './authPaths';
import { useLanguage } from '../../contexts/LanguageContext';
import './auth.css';

/**
 * Первая дверь кабинета: регистрация или вход.
 */
export const AuthChoicePage: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="m3-auth-screen">
      <div className="m3-auth-card">
        <span className="qp-auth-eyebrow">{t.auth.choiceEyebrow}</span>
        <h1 className="m3-headline">{t.auth.choiceTitle}</h1>
        <p className="m3-body" style={{ marginBottom: 24 }}>
          {t.auth.choiceSubtitle}
        </p>

        <Link to={AUTH_PATHS.register} className="qp-auth-choice qp-auth-choice--accent">
          <span className="qp-auth-choice-title">{t.auth.choiceNewVenueTitle}</span>
          <span className="qp-auth-choice-sub">
            {t.auth.choiceNewVenueSub}
          </span>
          <span className="qp-auth-choice-action">{t.auth.choiceNewVenueAction}</span>
        </Link>

        <Link to={AUTH_PATHS.login} className="qp-auth-choice">
          <span className="qp-auth-choice-title">{t.auth.choiceExistingVenueTitle}</span>
          <span className="qp-auth-choice-sub">{t.auth.choiceExistingVenueSub}</span>
        </Link>
      </div>
    </div>
  );
};
